import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";
import FeaturesSection from "../components/FeaturesSection";
import FeaturedProductsSlider from "../components/FeaturedProductsSlider";
import BestSellingProductsGrid from "../components/BestSellingProductsGrid";
import CategoryShowcase from "../components/CategoryShowcase";
import NewArrivalOne from "../components/NewArrivalOne";
import WhyChooseUs from "../components/WhyChooseUs";
import BrandStory from "../components/BrandStory";
import ShippingOne from "../components/ShippingOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
const HomePageOne = () => {

  return (

    <>

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Hero Slider */}
      <BannerOne />

      {/* Alt Kategoriler Slider */}
      <FeatureOne />

      {/* Featured Products Slider - Öne Çıkan Ürünler */}
      <FeaturedProductsSlider />

      {/* Best Selling Products Grid - En Çok Satanlar */}
      <BestSellingProductsGrid />

      {/* Category Showcase - Ana Kategori Grid */}
      <CategoryShowcase />

      {/* New Arrivals - Yeni Ürünler */}
      <NewArrivalOne />

      {/* Why Choose Us - Neden Biz? */}
      <WhyChooseUs />

      {/* Brand Story - Marka Hikayesi */}
      <BrandStory />

      {/* Shipping Information - Teslimat Bilgisi */}
      <ShippingOne />

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default HomePageOne;
